export type FeedbackKind = 'bug' | 'feature';
export type FeedbackSeverity = 'blocking' | 'major' | 'minor';
export type FeedbackStatus = 'new' | 'triaged' | 'in_progress' | 'shipped' | 'declined';

export interface FeedbackReport {
  id: string;
  kind: FeedbackKind;
  title: string;
  body: string;
  severity: FeedbackSeverity | null;
  status: FeedbackStatus;
  reporterId: string;
  reporterEmail: string | null;
  route: string | null;
  appVersion: string | null;
  userAgent: string | null;
  triagedBy: string | null;
  triageNote: string | null;
  triagedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * What the reporter actually types. Everything else on the row is either
 * captured from the running app or set by triage.
 */
export interface CreateFeedbackInput {
  kind: FeedbackKind;
  title: string;
  body: string;
  severity: FeedbackSeverity | null;
}

export interface FeedbackQueueFilters {
  status: FeedbackStatus | 'open' | 'all';
  kind: FeedbackKind | 'all';
}

export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  new: 'New',
  triaged: 'Triaged',
  in_progress: 'In progress',
  shipped: 'Shipped',
  declined: 'Declined',
};

export const FEEDBACK_SEVERITY_LABELS: Record<FeedbackSeverity, string> = {
  blocking: "Blocking — can't work",
  major: 'Major — painful workaround',
  minor: 'Minor — annoyance',
};

/** Statuses that still need someone to act. Drives the default triage view. */
export const OPEN_FEEDBACK_STATUSES: FeedbackStatus[] = ['new', 'triaged', 'in_progress'];
